import {Calculation, Language, Translations, Dates} from "@salaxy/core";
/**
 * Helper class used to create totalReport config for sxy-table and create tableData for ExcelHelpers(ng1)
 */
export class TotalsReportConfigGenerator{
  /**
   * Generates config for SxyTable component
   * @param calcs Calculations for report
   * @param lang Language for report
   * @returns Configuration for SxyTable component
   */
  public static getConfig(calcs: Calculation | Calculation[], lang: Language):{ options: any, include: any[], data: any[]} {
    const getData = (): any[] => {
      const result: any[] = [];
      const keys = ["baseSalary", "benefits", "totalTaxable", "tax", "totalExpenses", "unionPayment", "foreclosure", "pension", "unemploymentInsurance", "otherDeductions", "salaryAdvance", "earnings", "deductions", "totalWorkerPayment"];
      (calcs as Calculation[]).forEach((calc: Calculation) => {
        result.push({
          worker: calc.worker?.avatar?.sortableName,
          baseSalary: calc.result?.totals?.totalGrossSalary,
          benefits: calc.result?.workerCalc?.benefits,
          totalTaxable: calc.result?.totals?.totalTaxable,

          tax: calc.result?.workerCalc?.tax ?? 0 + (calc.result?.workerCalc?.taxAtSource ?? 0),
          totalExpenses: calc.result?.totals?.totalExpenses ?? 0 - (calc.result?.workerCalc?.prepaidExpenses ?? 0),
          unionPayment: calc.result?.workerCalc?.unionPayment,
          foreclosure: calc.result?.workerCalc?.foreclosure,
          pension: calc.result?.workerCalc?.pension,
          unemploymentInsurance: calc.result?.workerCalc?.unemploymentInsurance,
          otherDeductions: calc.result?.workerCalc?.otherDeductions,
          salaryAdvance: calc.result?.workerCalc?.salaryAdvance,
          earnings: (calc.result?.totals?.totalGrossSalary ?? 0) + (calc.result?.totals?.totalExpenses ?? 0),
          deductions: calc.result?.workerCalc?.deductions,
          totalWorkerPayment: calc.result?.workerCalc?.totalWorkerPayment,
        });
      });
      // If more than one calculation, create total row at end of table

      if((calcs as Calculation[]).length > 1) {
        const initialValues = {};
        keys.forEach(key => {
          initialValues[key] = 0;
        });
        const total = result.reduce(
          (prev, next) => {
            return {
              worker: "",
              baseSalary: prev.baseSalary + next.baseSalary,
              benefits: prev.benefits + next.benefits,
              totalTaxable: prev.totalTaxable + next.totalTaxable,
              tax: prev.tax + next.tax,
              totalExpenses: prev.totalExpenses + next.totalExpenses,
              unionPayment: prev.unionPayment + next.unionPayment,
              foreclosure: prev.foreclosure + next.foreclosure,
              pension: prev.pension + next.pension,
              unemploymentInsurance: prev.unemploymentInsurance + next.unemploymentInsurance,
              otherDeductions: prev.otherDeductions + next.otherDeductions,
              salaryAdvance: prev.salaryAdvance + next.salaryAdvance,
              earnings: prev.earnings + next.earnings,
              deductions: prev.deductions + next.deductions,
              totalWorkerPayment: prev.totalWorkerPayment + next.totalWorkerPayment
            };
          }, initialValues);
          result.push(total);
      }
      return result;
    };
    const getConfig =  ():{ options: any, include: any[], data: any[]}  => {
      return {
        include: [
          {title: Translations.get("SALAXY.REPORTS.totals.table.worker", null, lang), field: "worker", frozen: true, minWidth: 100},
          {title: Translations.get("SALAXY.REPORTS.totals.table.baseSalary", null, lang), field: "baseSalary", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: true, decimal: ",", thousand: " ", }},
          {title: Translations.get("SALAXY.REPORTS.totals.table.benefits", null, lang), field: "benefits", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: true, decimal: ",", thousand: " ", }},
          {title: Translations.get("SALAXY.REPORTS.totals.table.totalTaxable", null, lang), field: "totalTaxable", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: true, decimal: ",", thousand: " ", }},
          {title: Translations.get("SALAXY.REPORTS.totals.table.tax", null, lang), field: "tax", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: true, decimal: ",", thousand: " ", }},
          {title: Translations.get("SALAXY.REPORTS.totals.table.totalExpenses", null, lang), field: "totalExpenses", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: true, decimal: ",", thousand: " ", }},
          {title: Translations.get("SALAXY.REPORTS.totals.table.unionPayment", null, lang), field: "unionPayment", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: true, decimal: ",", thousand: " ", }},
          {title: Translations.get("SALAXY.REPORTS.totals.table.foreclosure", null, lang), field: "foreclosure", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: true, decimal: ",", thousand: " ", }},
          {title: Translations.get("SALAXY.REPORTS.totals.table.pension", null, lang), field: "pension", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: true, decimal: ",", thousand: " ", }},
          {title: Translations.get("SALAXY.REPORTS.totals.table.unemploymentInsurance", null, lang), field: "unemploymentInsurance", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: true, decimal: ",", thousand: " ", }},
          {title: Translations.get("SALAXY.REPORTS.totals.table.otherDeductions", null, lang), field: "otherDeductions", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: true, decimal: ",", thousand: " ", }},
          {title: Translations.get("SALAXY.REPORTS.totals.table.salaryAdvance", null, lang), field: "salaryAdvance", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: true, decimal: ",", thousand: " ", }},
          {title: Translations.get("SALAXY.REPORTS.totals.table.earnings", null, lang), field: "earnings", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: true, decimal: ",", thousand: " ", }},
          {title: Translations.get("SALAXY.REPORTS.totals.table.totalDeductions", null, lang), field: "deductions", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: true, decimal: ",", thousand: " ", }},
          {title: Translations.get("SALAXY.REPORTS.totals.table.totalWorkerPayment", null, lang), field: "totalWorkerPayment", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: true, decimal: ",", thousand: " ", }},
        ],
        options: {
          selectable: false,
          layout: "fitData",
        },
        data: getData()
      };
    };
    return getConfig();
  }

  /** Generates tableData for ExcelHelpers.export (ng1) */
  public static getTableData(calcs: Calculation[], lang: Language): any[] {
    const result: any[] = [];
    const headers = [
      Translations.get("SALAXY.REPORTS.totals.table.company", null, lang),
      Translations.get("SALAXY.REPORTS.totals.table.officialId", null, lang),
      Translations.get("SALAXY.REPORTS.totals.table.worker", null, lang),
      Translations.get("SALAXY.REPORTS.totals.table.salaryPeriod", null, lang),
      Translations.get("SALAXY.REPORTS.totals.table.salaryDate", null, lang),
      Translations.get("SALAXY.REPORTS.totals.table.baseSalary", null, lang),
      Translations.get("SALAXY.REPORTS.totals.table.benefits", null, lang),
      Translations.get("SALAXY.REPORTS.totals.table.totalTaxable", null, lang),
      Translations.get("SALAXY.REPORTS.totals.table.tax", null, lang),
      Translations.get("SALAXY.REPORTS.totals.table.totalExpenses", null, lang),
      Translations.get("SALAXY.REPORTS.totals.table.unionPayment", null, lang),
      Translations.get("SALAXY.REPORTS.totals.table.foreclosure", null, lang),
      Translations.get("SALAXY.REPORTS.totals.table.pension", null, lang),
      Translations.get("SALAXY.REPORTS.totals.table.unemploymentInsurance", null, lang),
      Translations.get("SALAXY.REPORTS.totals.table.otherDeductions", null, lang),
      Translations.get("SALAXY.REPORTS.totals.table.salaryAdvance", null, lang),
      Translations.get("SALAXY.REPORTS.totals.table.earnings", null, lang),
      Translations.get("SALAXY.REPORTS.totals.table.totalDeductions", null, lang),
      Translations.get("SALAXY.REPORTS.totals.table.totalWorkerPayment", null, lang)
    ];
    result.push(headers);
    calcs.forEach(calc => {
      const row: any[] = [];
      row.push(calc.employer?.avatar?.displayName);
      row.push(calc.employer?.officialId);
      row.push(calc.worker?.avatar?.sortableName);
      row.push(Dates.getFormattedRange(calc.info?.workStartDate ?? "", calc.info?.workEndDate ?? ""));
      row.push(Dates.getFormattedDate(calc.workflow?.salaryDate));
      row.push(calc.result?.totals?.totalGrossSalary);
      row.push(calc.result?.workerCalc?.benefits);
      row.push(calc.result?.totals?.totalTaxable);
      row.push((calc.result?.workerCalc?.tax ?? 0) + (calc.result?.workerCalc?.taxAtSource ?? 0));
      row.push((calc.result?.totals?.totalExpenses ?? 0) - (calc.result?.workerCalc?.prepaidExpenses ?? 0));
      row.push(calc.result?.workerCalc?.unionPayment);
      row.push(calc.result?.workerCalc?.foreclosure);
      row.push(calc.result?.workerCalc?.pension);
      row.push(calc.result?.workerCalc?.unemploymentInsurance);
      row.push(calc.result?.workerCalc?.otherDeductions);
      row.push(calc.result?.workerCalc?.salaryAdvance);
      row.push((calc.result?.totals?.totalGrossSalary ?? 0) + (calc.result?.totals?.totalExpenses ?? 0));
      row.push(calc.result?.workerCalc?.deductions);
      row.push(calc.result?.workerCalc?.totalWorkerPayment);
      result.push(row);

    });
    return result;
  }
}